<template>
  <div
    class="unvote"
    :class="{
      'is-enable-vote': isEnableVote
    }"
  >
    <div class="unvote-inner">
      <button
        v-if="isEnableVote"
        class="button-vote"
        :class="[this.$route.params.lang]"
        @click="goSelectTypePage"
        v-html="$t('btn001')"
      />
      <img
        :src="require(`@images/mypage/${$route.params.lang}/txt_day${day}.png`)"
        class="day"
        :alt="$t('day001', { day: this.day})"
      >
    </div>
    <p class="status" v-html="$t('label002')" />
  </div>
</template>

<script>
import localeMypage from '@locales/mypage'
export default {
  name: 'unvote',
  $messages: localeMypage,
  props: {
    isEnableVote: {
      type: Boolean,
      required: true
    },
    day: {
      type: Number,
      required: true
    }
  },
  methods: {
    goSelectTypePage() {
      this.$router.push(`/${this.$route.params.lang}/select-type`)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.unvote {
  display: flex;
  flex-direction: column;
  align-items: center;
  &-inner {
    background-image: url(~@images/mypage/bg_feature-piece.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    height: 183px;
    width: 180px;
    position: relative;
  }
  .day {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.is-enable-vote {
    .unvote-inner {
      background-image: url(~@images/mypage/bg_past-piece.png);
      position: relative;
    }
    .day {
      position: absolute;
      top: 125px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.button-vote {
  background-repeat: no-repeat;
  background-size: 100% auto;
  height: 70px;
  width: 180px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @include hidden-text();
  @include tap-event();
  &.ja-JP {
    background-image: url(#{$img-path}mypage/ja-JP/btn_vote-mini.png);
  }
  &.de-DE {
    background-image: url(#{$img-path}mypage/de-DE/btn_vote-mini.png);
  }
  &.en-GB {
    background-image: url(#{$img-path}mypage/en-GB/btn_vote-mini.png);
  }
  &.en-US {
    background-image: url(#{$img-path}mypage/en-US/btn_vote-mini.png);
  }
  &.es-ES {
    background-image: url(#{$img-path}mypage/es-ES/btn_vote-mini.png);
  }
  &.es-MX {
    background-image: url(#{$img-path}mypage/es-MX/btn_vote-mini.png);
  }
  &.fr-CA {
    background-image: url(#{$img-path}mypage/fr-CA/btn_vote-mini.png);
  }
  &.fr-FR {
    background-image: url(#{$img-path}mypage/fr-FR/btn_vote-mini.png);
  }
  &.it-IT {
    background-image: url(#{$img-path}mypage/it-IT/btn_vote-mini.png);
  }
  &.pt-BR {
    background-image: url(#{$img-path}mypage/pt-BR/btn_vote-mini.png);
  }
  &.zh-TW {
    background-image: url(#{$img-path}mypage/zh-TW/btn_vote-mini.png);
  }
}
    .status {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-size: 100%  100%;
  background-position: center;
  text-align: center;
  padding: 5px 0;
  width: 100%;
}
</style>
